import React from 'react';
import PropTypes from 'prop-types';

import Row from 'zignal-landscape/lib/Row';
import Col from 'zignal-landscape/lib/Col';
import GridContent from 'zignal-landscape/lib/GridContent';
import Link from 'zignal-landscape/lib/Link';
import Select from 'zignal-landscape/lib/Select';
import themeable from 'zignal-landscape/lib/themeable';

const DefaultLocationsTableFooter = ({
  styles,
  total = 0,
  totalPages = 0,
  currentPage = 1,
  pageSize = 50,
  onPageChange,
  onPageSizeChange,
}) => {
  const offset = (currentPage - 1) * pageSize;
  const fromCount = total > 0 ? offset + 1 : 0;
  const toCount = Math.min(offset + pageSize, total);

  const pagesDisplayedInfo = toCount > 0
    ? `Showing ${fromCount} to ${toCount} of ${total} Default Locations`
    : '';

  const isPrevDisabled = currentPage <= 1;
  const isNextDisabled = currentPage >= totalPages || totalPages === 0;

  return (
    <div className={styles.tableFooterContainer}>
      <Row>
        <Col xs={7}>
          <GridContent>
            <span className={styles.spanBlock}>Show</span>
            <div className={styles.elementsPerPage}>
              <Select
                searchable={false}
                options={[
                  { value: 25, label: 25 },
                  { value: 50, label: 50 },
                  { value: 100, label: 100 },
                  { value: 200, label: 200 },
                ]}
                onChange={onPageSizeChange}
                value={{value: pageSize, label: pageSize}}
              />
            </div>
            <span>Default Locations.</span>
            <span className={styles.displayedPagesInfo}>{pagesDisplayedInfo}</span>
          </GridContent>
        </Col>
        <Col xs={5}>
          <GridContent>
            <div className={styles.tableButtonsContainer}>
              <div className={styles.tableLink}>
                <Link linkType="cancel" disabled={isPrevDisabled} onClick={() => !isPrevDisabled && onPageChange(1)}>First</Link>
              </div>
              <div className={styles.tableLink}>
                <Link linkType="cancel" disabled={isPrevDisabled} onClick={() => !isPrevDisabled && onPageChange(currentPage - 1)}>Prev</Link>
              </div>
              <div className={styles.tableLink}>
                <Link linkType="cancel" disabled={isNextDisabled} onClick={() => !isNextDisabled && onPageChange(currentPage + 1)}>Next</Link>
              </div>
              <div className={styles.tableLink}>
                <Link linkType="cancel" disabled={isNextDisabled} onClick={() => !isNextDisabled && onPageChange(totalPages)}>Last</Link>
              </div>
            </div>
          </GridContent>
        </Col>
      </Row>
    </div>
  );
};

DefaultLocationsTableFooter.propTypes = {
  styles: PropTypes.object.isRequired,
  total: PropTypes.number,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

export default themeable(DefaultLocationsTableFooter);
